import Vue from 'vue'
import store from "@/store"

var FileSelectPromptContent = Vue.extend({
  template: `
  <div>
    <el-upload
      drag
      ref="upload"
      action=""
      :limit="1"
      :accept="accept"
      :auto-upload="false"
      :on-change="handleChange">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
      <div class="el-upload__tip" slot="tip">Json file with a size less than 1024 kb</div>
    </el-upload>
  </div>
  `,
  props: {
    accept: {},
  },
  beforeCreate() {
    this.$store = store;
  },
  data: () => ({
    file: null
  }),
  methods: {
    handleChange(file, filelist) {
      // TODO: Delete other entries
      // console.log("handleChange", file);
      // filelist = filelist.pop()

      this.file = file;
    },
    reset() {
      this.$refs.upload.clearFiles()
      this.file = null;
    }
  }
})

export default {
  methods: {
    $file_prompt({ title, accept } = {}) {
      return new Promise((resolve, reject) => {
        this.$msgbox({
          title: title || 'Select a file',
          message: this.$createElement(FileSelectPromptContent, {
            props: { accept: accept || 'image/*' }
          }),
          showCancelButton: true,
          beforeClose: (action, instance, done) => {

            let dataContainer = instance.$children.find( child => 'file' in child )

            let done_with_reset = () => {
              done();
              dataContainer.reset();
            }

            if ( action !== 'confirm' || !dataContainer.file ) {
              done_with_reset();
              return
            }

            resolve({
              done: done_with_reset,
              ...dataContainer._data
            })
          }
        }).catch(e => e);
      })
    }
  }
}
